export default {
  cancel: '取消',
  saveSuccessfully: '保存成功',
  pleaseEnterAnIntegerGreaterThan: '请输入大于0的整数',
  save: '保存',
  pleaseFillInTheLowerMeasuringRange: '请填写量程下限',
  lowerRange: '量程下限',
  pleaseFillInTheUpperMileageLimit: '请填写量程上限',
  maximumRange: '量程上限',
  pleaseFillInTheExpression: '请填写表达式',
  expression: '表达式',
  measurementPointType: '测点类型',
  pleaseFillinTheMeasurementPointPeriod: '请填写测点周期',
  measurementPointPeriod: '测点周期',
  pleaseFillInTheUnit: '请填写单位',
  PleaseFillInTheNameOfTheMeasurementPoint: '请填写测点名称',
  pleaseFillInTheMeasuremenPointCode: ' 请填写测点编码',
  shortName: '简称',
  PleaseFillInShortName: '请填写简称',
  listOfMeasurementPoints: '测点清单.xlsx',
  noRecordsAreCurrentlySelected:
    '当前没有选中任何记录,系统将默认导出系统中所有数据,该操作耗时较长,请确认是否要继续?',
  NotCurrentlySelected:
    '您没有选中任何记录,将导出当前目录全部数据,该操作时间会比较长,请确认是否要继续?',
  synchronizationAttention: '同步数据耗时较长,请谨慎操作！',
  theDeletionHasBeenCanceled: '已取消删除',
  theDeletionWasSuccessful: '删除成功',
  confirm: '确认',
  hint: '提示',
  whetherToDeleteTheSelectedData: '是否删除选中的数据',
  PleaseSelectTheDataYouWantToDelete: '请选择要删除的数据',
  switchingAmount: '开关量',
  analogue: '模拟量',
  theListOfMeasurementPointsIsImportedIntoTheTemplate: '测点清单导入模版.xlsx',
  viewMeasurementPoints: '查看测点',
  editTheMeasurementPoints: '编辑测点',
  addedMeasurementPoints: '新增测点',

  detail: '详情',
  measurementPointDrive: '测点驱动',
  measurementPointPeriodMs: '测点周期(ms)',
  unit: '单位',
  associateTheDevice: '关联设备',
  measurementPointCoding: '测点编码',
  measurementPointName: '测点名称',
  measurementPointShortName: '测点简称',

  bulkDeletion: '批量删除',
  search: '搜索',
  measurementPointCodeOrMeasurementPointName: '测点编码或测点名称',
  deleteAMeasurementPoint: '删除测点',

  shareGroupings: '分享分组',
  rename: '重命名',
  addMeasurementPoints: '添加测点',
  addedgGrouping: '新增分组',
}
